import React from 'react';
import { connect } from 'react-redux';
import {getIsFormValidating, getIsLoadingSurnameCheck, getSurname, getSurnameStatus} from "../../selectors";
import {changeSurname,} from "../../reducers";
import {showLoader} from "../../utils";
import {FORM_CONSTRAINTS} from "../../constants";

const stateToProps = state => ({
    isFormValidating: getIsFormValidating(state),
    surnameStatus: getSurnameStatus(state),
    isLoadingSurnameCheck: getIsLoadingSurnameCheck(state),
    surname: getSurname(state),
});

const actionsToProps = dispatch => ({
    changeSurname: payload => dispatch(changeSurname(payload)),
});

const Surname = props => {

    return (
        <div className={`form-row ${props.surnameStatus}`}>
            <label className="form-label" htmlFor="surname">
                {props.isLoadingSurnameCheck && showLoader()}
                Surname <span className="asterisk">*</span>
            </label>
            <input type="text" className="form-input" id="surname" onBlur={() => props.checkSurname('surname')}
                   value={props.surname} disabled={props.isFormValidating}
                   onChange={e => {
                       const surname = e.target.value.trim();
                       if (surname.length <= FORM_CONSTRAINTS.surname.max_length) {
                           props.changeSurname({
                               surname: surname,
                               surnameStatus: 'none',
                               surnameErrorMessage: '',
                           })}
                   }
                   }
            />

            <p className="callout error p10 txt-l">
                Invalid Surname format. Min. {FORM_CONSTRAINTS.surname.min_length} characters and max. {FORM_CONSTRAINTS.surname.max_length}.
                Special characters and numbers are not allowed. First and Last Name cannot be same.
            </p>
            <i className="form-status" />
        </div>
    );
}

export default connect(
    stateToProps,
    actionsToProps
)(Surname);
